import React, { useEffect } from "react";
import AppBody from "../../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getTrainingSyllabus } from "../../../actions/learning_provider/training_syllabus_action";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  addUserTrainingAttendance,
  addUserTrainingRating,
  checkTrainingStartStatus,
  getUserWiseTrainingDetails,
  resetTrainingStartStatus,
} from "../../../actions/learning_provider/provider_user/training_action";
import { setRecordingUrl } from "../../../actions/learning_provider/training_action";
import { UI_URL } from "../../../config/api";

const UserTrainingDetailsList = () => {
  //const state = useSelector((state) => state.trainingSyllabusReducer);
  const state = useSelector((state) => state.puTrainingReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [closeMeetingPopup, setCloseMeetingPopup] = useState(false);
  const [openMeeting, setOpenMeeting] = useState(false);
  const [ratingCount, setRatingCount] = useState(0);
  const [topic, setTopic] = useState({});
  const { slug } = useParams();
  const ratingArr = [1, 2, 3, 4, 5];

  useEffect(() => {      
      dispatch(getUserWiseTrainingDetails({ slug: slug }));
  }, []);

  const playTraining = () => {
    setOpenMeeting(false);
    dispatch(checkTrainingStartStatus({ slug: slug }));
    //dispatch(addUserTrainingAttendance({ id: id }));
    // navigate("/training/start/" + btoa(id));
    //window.open(UI_URL + "/training/start/" + btoa(id));
  };

  if (
    state.checkTopicSatus === 1 &&
    !state.loading &&
    !openMeeting
  ) {
    localStorage.setItem("trTopicId", state.topicId);
    dispatch(addUserTrainingAttendance({ id: state.topicId }));
    setOpenMeeting(true);
    window.open(UI_URL + "/training/start/" + btoa(state.topicId));
  } else {
    if (state.checkTopicSatus === 0 && !open) {
      setOpen(true);
    }
  }

  const playRecording = (url) => {
    dispatch(setRecordingUrl(url));
    navigate("/recording");
  };

  if (state.is_done) {
    dispatch(getUserWiseTrainingDetails({ slug: slug }));
    dispatch(resetTrainingStartStatus());
    setShow(false);
    setTopic({});
    setRatingCount(0);
  }

  const showRatingPopup = (li) => {
    setTopic(li);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setTopic({});
    setRatingCount(0);
  };

  const handleMeetingClose = () => {
    setOpen(false);
    dispatch(resetTrainingStartStatus());
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/my-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Training Topics
              </h4>
              <div className="col text-right pr-0">
                <a
                  className="line-height-36 custom-icon mr-2"
                  title="Join Training"
                  onClick={() => playTraining()}
                >
                  <i className="feather-play"></i>
                </a>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Topic Name</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                       <th>Rating</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.topics &&
                      state.topics.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.session_topic}</td>
                          <td>{li.ustart_time ? li.ustart_time : "-"}</td>
                          <td>{li.uend_time ? li.uend_time : "-"}</td>
                          <td>{li.urating ? li.urating : "-"}</td>
                          <td>
                            {li.status === 1
                              ? "Starting"
                              : li.status === 2
                              ? "Completed"
                              : "Schedule"}
                          </td>
                          <td>
                            {li.recording_url && (
                              <a
                                className="line-height-36 custom-icon mr-2"
                                title="Play Recording"
                                target="_blank"
                                onClick={() => playRecording(li.recording_url)}
                              >
                                <i className="fa-solid fa-record-vinyl"></i>
                              </a>
                            )}
                            <a
                              className={`line-height-36 custom-icon mr-2 ${
                                li.status !== 2 && "readonly-nav"
                              }`}
                              title="Rating"
                              target="_blank"
                              onClick={() => showRatingPopup(li)}
                            >
                              <i className="fa fa-star"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <Modal show={show} onHide={handleClose}>
              <Modal.Header>
                <Modal.Title
                  className={"color-white"}
                  style={{ color: "aliceblue", fontWeight: 700 }}
                >
                  {topic && topic.session_topic}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="err-model-body">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss color-white">
                    Add Rating to topic..
                  </label>
                  <br />
                  {ratingArr.map((arr, i) => (
                    <a
                      className={
                        ratingCount >= i + 1
                          ? "line-height-36 custom-icon mr-2"
                          : "line-height-36 rating-icon mr-2"
                      }
                      title="Rating"
                      target="_blank"
                      onClick={() => setRatingCount(i + 1)}
                    >
                      <i className="fa fa-star"></i>
                    </a>
                  ))}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="tr-popup-btn"
                  onClick={() =>
                    dispatch(
                      addUserTrainingRating({
                        rating: ratingCount,
                        id: topic.id,
                      })
                    )
                  }
                >
                  Add Rating
                </button>
                <button className="tr-popup-btn" onClick={() => handleClose()}>
                  Close
                </button>
              </Modal.Footer>
            </Modal>

            <Modal show={open} onHide={handleMeetingClose}>
              <Modal.Header>
                <Modal.Title
                  className={"color-white"}
                  style={{ color: "aliceblue", fontWeight: 700 }}
                >
                  {slug}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="err-model-body">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss color-white">
                    Waiting for the host to start the training, please standby !
                  </label>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="tr-popup-btn"
                  onClick={() => handleMeetingClose()}
                >
                  Close
                </button>
                <button
                  className="tr-popup-btn"
                  onClick={() =>
                    dispatch(checkTrainingStartStatus({ slug: slug }))
                  }
                >
                  Join Again
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      }
    />
  );
};

export default UserTrainingDetailsList;
